import React, { useState, useRef, useEffect } from "react";
import { Plus, X, StarFill, BookmarkFill } from "react-bootstrap-icons";
import { Overlay, Tooltip } from 'react-bootstrap';

import { getNotchIcon } from 'services/notches';

import "./styles.css";

const OmniButton = ({
    favorites,
    setCurrentState,
    handleAddFromFavorite
}) => {
    const [expanded, setExpanded] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);
    const favRef = useRef(null);
    const btnRef = useRef(null);

    const quickAccessItems = favorites.filter(item => item.quick_access === true);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (btnRef.current && !btnRef.current.contains(event.target)) {
                setExpanded(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <>
            <button
                type="button"
                className="btn d-flex align-items-center justify-content-center shadow round-button"
                style={{ 
                    cursor: "pointer" 
                }}
                onClick={(e) => {
                    e.preventDefault();

                    setExpanded(prev => !prev);
                }}
            >
                {!expanded ? <Plus size={80} /> : <X size={80} />}
            </button>

            {/* Context Menu */}
            {expanded && (
                <div 
                    className="round-button-context"
                    ref={btnRef}
                >
                    <ul className="list-group context-list-group">
                        {quickAccessItems.length > 0 && (
                            <>
                                {quickAccessItems.map((item, index) => (
                                    <li 
                                        key={item.uid}
                                        className="list-group-item list-group-item-action px-2"
                                        style={{ cursor: "pointer" }}
                                        onClick={(e) => {
                                            e.preventDefault();

                                            handleAddFromFavorite(item);

                                            setExpanded(false);
                                        }}
                                    >
                                        {getNotchIcon(
                                            item.type,
                                            {
                                                color: item.color ?? null
                                            }
                                        )} {item.notch}
                                    </li>
                                ))}

                                <hr className="m-0 border-top border-2" />
                            </>
                        )}

                        <Overlay target={favRef.current} show={showTooltip} placement="top">
                            {(props) => (
                                <Tooltip id="fav-tooltip" {...props}>
                                    Please add some favorite notches in Collection
                                </Tooltip>
                            )}
                        </Overlay>
                        <li
                            ref={favRef}
                            className="list-group-item list-group-item-action px-2"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                                e.preventDefault();

                                if (favorites.length === 0) {
                                    setShowTooltip(true);

                                    setTimeout(() => setShowTooltip(false), 3000);
                                } else {
                                    setCurrentState('add_from_favorites');
                                }
                            }}
                        >
                            <StarFill /> New From Favorites
                        </li>
                        <li
                            className="list-group-item list-group-item-action px-2"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                                e.preventDefault();
                                setCurrentState('add');
                            }}
                        >
                            <BookmarkFill /> New Notch
                        </li>
                    </ul>
                </div>
            )}
        </>
    );
};

export default OmniButton; 